export default "__VITE_ASSET__Grini0xM__"